<template>
    <component class="content-subheading" :is="headingComponent" :class="headingClasses">
        {{ heading }}
    </component>
</template>

<script>
export default {
    name: 'ContentSubheading',
    props: {
        heading: {
            required: false,
            type: String,
            default: null,
        },
        headingColor: {
            required: false,
            type: String,
            default: 'text-yellow-400',
        },
        headingComponent: {
            required: false,
            type: String,
            default: 'h1',
        },
        marginBottom: {
            required: false,
            type: String,
            default: 'mb-0',
        },
        textCentered: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
    },
    computed: {
        headingClasses() {
            const cls = {};
            cls['text-xl font-bold tracking-tight sm:text-2xl'] = true;
            cls[this.headingColor] = true;
            cls[this.marginBottom] = true;
            cls['text-center'] = !!this.textCentered;
            return cls;
        },
    },
};
</script>
